// extracted by mini-css-extract-plugin
module.exports = {"doughnutChartWrapper":"styles_doughnutChartWrapper__vQB4U","doughnutWrapper":"styles_doughnutWrapper__JWFKV","doughnutChartTitle":"styles_doughnutChartTitle__C8ABT","infoIcon":"styles_infoIcon__M_PmE","demographicWrapper":"styles_demographicWrapper__3fCGG"};
module.exports.__checksum = "5f7b84b9037d"
